import {
	RefObject,
	useEffect,
	useRef,
	useState
} from "react";

const TIMEOUT_DELAY = 300;

export function useShouldStartLoadingData(
	isPinned: boolean,
	isVisible: boolean
): boolean {
	const [shouldStartLoadingData, setShouldStartLoadingData] = useState<boolean>(false);
	const timeoutIdRef: RefObject<undefined | SetTimeoutHandle> = useRef(undefined);

	useEffect(
		(): void | undefined => {
			if (shouldStartLoadingData) {
				return;
			}

			if (isPinned) {
				setShouldStartLoadingData(true);
				return;
			}

			if (isVisible) {
				timeoutIdRef.current = setTimeout(
					(): void => {
						setShouldStartLoadingData(true);
					},
					TIMEOUT_DELAY
				);
			}
		},
		[
			isPinned,
			isVisible,
			shouldStartLoadingData
		]
	);

	useEffect(
		(): void => {
			if (!isVisible) {
				clearTimeout(timeoutIdRef.current);
			}
		},
		[isVisible]
	);

	useEffect(
		(): (() => void) => {
			return () => clearTimeout(timeoutIdRef.current);
		},
		[]
	);

	return shouldStartLoadingData;
}